module.exports = __webpack_public_path__ + "static/img/case-zg-page-bg-01.6e49d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zg/case-zg-page-bg-01.jpg
// module id = 2SDe
// module chunks = 1